import { useEffect } from 'react';
import { useFormik } from 'formik';
import _ from 'lodash';
import { getBtnProps, TransitionBtn, useGetAddressInfo } from 'views/components/pages/accountEstablishment/hooks';
import {
  CostomerInfoFormikType,
  costomerInfoValidation,
  costomerInfoInitialValues,
  costomerInfoOnSubmit,
} from 'views/utils/accountEstablish';
import { ButtonProps } from 'views/components/atoms/button';
import { AccountInfoUpdateRequestParam, useAccountInfoUpdateStore } from './useUpdatePage';
import { MaskType } from 'views/components/atoms/establishes/text';

export const useCostomerInfoUpdate = () => {
  const { param, add } = useAccountInfoUpdateStore();
  const initialValues = costomerInfoInitialValues(param);
  const onSubmit = costomerInfoOnSubmit<AccountInfoUpdateRequestParam>(param, add);

  const formik: CostomerInfoFormikType = useFormik({
    initialValues,
    enableReinitialize: true,
    validationSchema: costomerInfoValidation(true),
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit,
  });

  const searchButtonProps: ButtonProps = getBtnProps(TransitionBtn.SEARCH_ADDRESS, () => getAddressInfo());

  const { addressInfo, getAddressInfo } = useGetAddressInfo(formik.values.postCode);

  useEffect(() => {
    if (!addressInfo.data) return;
    formik.setFieldValue('prefecture', addressInfo.data.GetAddressInfo?.Prefecture);
    formik.setFieldValue('cityCounty', addressInfo.data.GetAddressInfo?.CityCounty);
    formik.setFieldValue('townStreetAddress', addressInfo.data.GetAddressInfo?.TownStreetAddress);
  }, [addressInfo]);

  return {
    formik,
    searchButtonProps,
    getAddressInfo,
    isUpdate: true,
    maskMap: {
      mobilePhoneNumber: { type: MaskType.Start, displayedCount: 4 },
      homePhoneNumber: { type: MaskType.Start, displayedCount: 4 },
      mailAddress: { type: MaskType.End, displayedCount: 4 },
    },
  };
};
